import { useQuasar } from "quasar";
import PConfirmDialog from "src/components/PConfirmDialog.vue";

export function useInitiate({ closeForm, formData }) {
  const $q = useQuasar();

  const { initiatePaymentRequest } = usePaymentRequestStore();

  const loading = ref(false);

  const onConfirm = async () => {
    try {
      loading.value = true;

      await initiatePaymentRequest(unref(formData));

      closeForm();
    } catch (error) {
      console.error(error);
    } finally {
      loading.value = false;
    }
  };

  const confirmInitiation = () => {
    $q.dialog({
      component: PConfirmDialog,
      componentProps: {
        cancelLabel: "Cancel",
        labelClass: "text-center q-ma-xl rounded-borders",
        submitLabel: "Confirm",
        label: `Are you sure you want to move it to Payments Initiated?`,
        onConfirm,
      },
    });
  };

  const initiateButton = computed(() => {
    return {
      loading: unref(loading),
      label: "Initiate",
      type: "button",
      onClick: confirmInitiation,
    };
  });

  return {
    initiateButton,
  };
}
